<template>
    <div style="display: flex;">
        <button @click="prevPage">
            <svg viewBox="0 0 1024 1024" width="64" height="64" class="floating-svg-l">
                <path d="M507.733333 490.666667L768 230.4 704 170.666667 384 490.666667l320 320 59.733333-59.733334-256-260.266666zM341.333333 170.666667H256v640h85.333333V170.666667z" fill="#444444" p-id="2584"></path>
            </svg>
        </button>
        <div class="canvas">
            <canvas ref="canvasL"></canvas>
            <div class="line"></div>
            <!-- style="margin-left: -2.35%;" -->
            <canvas ref="canvasR"></canvas>
        </div>
        <button @click="nextPage">
            <svg viewBox="0 0 1024 1024" width="64" height="64" class="floating-svg-r">
                <path d="M516.266667 490.666667L256 230.4 315.733333 170.666667l320 320L315.733333 810.666667 256 750.933333l260.266667-260.266666zM678.4 170.666667h85.333333v640h-85.333333V170.666667z" fill="#444444"></path>
            </svg>
        </button>
    </div>
</template>

<script>
import {getBookInfo} from '../../api'

export default {
    data() {
        return {
            currentPage: 0,
            imgUrls: [],
            imgs: [],
        };
    },
    mounted() {
        this.loadBook();
        window.addEventListener('keydown', this.KeyDown);
        this.canvasL = this.$refs.canvasL;
        this.ctxL = this.canvasL.getContext('2d');
        let width =  Math.max(window.innerWidth * 0.6 / 2)
        // let height = window.innerHeight + 50;
        let height = Math.min(width * 1.3, window.innerHeight + 50);
        width = height / 1.3

        if (width < 650){
            height = window.innerHeight + 50;
            width = height / 1.3
        }

        this.canvasL.width = width;
        this.canvasL.height = height;

        this.canvasR = this.$refs.canvasR;
        this.ctxR = this.canvasR.getContext('2d');
        this.canvasR.width = width;
        this.canvasR.height = height;
    },
    beforeUnmount(){
        window.removeEventListener('keydown', this.KeyDown);
    },
    methods: {
    KeyDown(event) {
        console.log(event.key)
        if (event.key === "ArrowLeft") {
            this.prevPage();
        }else if (event.key === "ArrowRight") {
            this.nextPage();
        }
    },
    drawPage() {
        const canvasWidth = this.canvasL.width;
        const canvasHeight = this.canvasL.height;

        // 清空画布
        this.ctxL.clearRect(0, 0, canvasWidth, canvasHeight);

        const img1 = this.imgs[0];
        this.ctxL.drawImage(img1, 0, 0, canvasWidth, canvasHeight);

        this.ctxR.clearRect(0, 0, canvasWidth, canvasHeight);
        const img2 = this.imgs[1];
        this.ctxR.drawImage(img2, 0, 0, canvasWidth, canvasHeight);
        // this.canvasL.style.transform = 'perspective(2000px) rotateY(10deg)';
        // this.canvasR.style.transform = 'perspective(2000px) rotateY(-10deg)';
    },
    nextPage() {
        if (this.currentPage < this.imgUrls.length){
            this.currentPage += 2;
            this.loadImg();
            this.drawPage();
        }
    },
    prevPage(){
        if (this.currentPage > 0){
            this.currentPage -= 2;
            this.loadImg();
            this.drawPage();
        }
    },
    loadImg() {
        const imgPromise1 = new Promise((resolve, reject) => {
            const img = new Image();
            img.src = this.imgUrls[this.currentPage];
            img.onload = () => resolve(img);
        });

        const imgPromise2 = new Promise((resolve, reject) => {
            const img = new Image();
            img.src = this.imgUrls[this.currentPage+1];
            img.onload = () => resolve(img);
        });

        Promise.all([imgPromise1, imgPromise2]).then(imgs => {
                this.imgs = imgs;
                this.drawPage();
        });
    },
    loadBook() {
        getBookInfo(this.$route.params.bookId).then(res => {
            if (res.data.size != 0) {
                let size = res.data.size;
                let url = res.data.path;
                let uuid = res.data.id;
                for (let i = 0; i < size; i++){
                    this.imgUrls.push(url + "/" + uuid + "-" + i + ".png")
                }
                this.loadImg();
            } 
        })
    },
    }
}
</script>

<style>

.canvas{
    display: block;
    margin: 0 auto;
}

.floating-svg-l {
    animation: floatingAnimationL 2s ease-in-out infinite alternate;
}

.floating-svg-r {
    animation: floatingAnimationR 2s ease-in-out infinite alternate;
}

@keyframes floatingAnimationL {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(30px);
    }
}

@keyframes floatingAnimationR {
    0% {
        transform: translateX(0);
    }
    100% {
        transform: translateX(-30px);
    }
}

.line {
    position: absolute;
    left: calc(50% - 1px);
    top: 0;
    height: 100%;
    width: 2px;
}

.line::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    border-left: 2px dashed gray;
}
</style>